/**
 * Created by jv on 27/04/2017.
 */
const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class DigitalPurchase
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.licenseGroupKey= options["license-group-key"];
    this.tokenCode = options["token-code"];

    this.title = options["product-title"];

    this.tokenMaxInstallations = options["token-max-installations"];
  }
};



// WEBPACK FOOTER //
// ./app/js/models/digital-purchase.js